<template>
  <div style="padding: 0 10px">
    <!-- <Form @search="searchCall"></Form> -->
    <div style="margin-bottom: 20px; text-align: left">
      <el-button type="primary" @click="createArea">创建库区</el-button>
    </div>
    <WmsTable
      :columns="columns"
      :dataSource="dataSource"
      :is-pagination="false"
    >
      <div
        slot="action"
        slot-scope="{ record }"
        style="display: flex; justify-content: center; align-items: center"
      >
        <a href="javascript:;" style="padding: 0 10px" @click="edit(record)"
          >编辑</a
        >
        <!-- <a href="javascript:;" style="padding: 0 10px" @click="del(record)"
          >删除</a
        > -->
      </div>
    </WmsTable>
    <SetArea
      ref="SetArea"
      @onSubmit="updata"
      @add="create"
      :warehouse="warehouse"
    />
  </div>
</template>

<script>
import Form from "@/views/configure/warehouseArea/components/Form";
import WmsTable from "@/components/WmsTable";
import SetArea from "@/views/configure/warehouseArea/components/SetArea";
import { columns } from "@/views/configure/warehouseArea/indexData";
import {
  getRegionList,
  updRegin,
  createRegin,
  warehouseList,
} from "@/apis/configure";
export default {
  title: "货格码",
  name: "ConfigureWarehouseArea",
  components: {
    WmsTable,
    SetArea,
    Form,
  },
  data() {
    return {
      columns,
      query: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      dataSource: [],
      warehouse: [],
    };
  },
  mounted() {
    this.getWarehouse();
    this.getDataSource()
  },
  methods: {
    searchCall: function (fromData) {
      let params = fromData;
      this.query.current = 1;
      this.query.total = 1;
      this.getDataSource(params);
    },
    pageChangeCall: function (payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    getDataSource: function (params) {
      getRegionList(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data;
        }
      });
    },
    createArea: function () {
      this.$refs["SetArea"].open();
    },
    edit: function (r) {
      this.$refs["SetArea"].open(r);
    },
    updata(r) {
      console.log(r);
      let params = r;
      updRegin(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success("修改成功");
          this.getDataSource();
        }
      });
    },
    create(r) {
      let params = r;
      createRegin(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success("添加成功");
          this.getDataSource();
        }
      });
    },
    del: function (r) {
      let that = this;
      let params = r;
      this.$confirm("确定删除该库区？", "删除提示", {
        confirmButtonText: "删除",
        type: "error",
        cancelButtonText: "取消",
      }).then(() => {
        params.beactive = 0;
        updRegin(params).then(({ code }) => {
          if (code === 0) {
            that.$message.success("删除成功");
            that.getDataSource();
          }
        });
      });
    },

    getWarehouse() {
      warehouseList().then(({ code, data }) => {
        if (code === 0) {
          this.warehouse = data;
        }
      });
    },
  },
};
</script>

<style scoped></style>
